export enum Environments {
  UNKNOWN = 'UNKNOWN',
  LOCAL = 'LOCAL',
  NIGHTLY = 'NIGHTLY',
  STABLE = 'STABLE',
  PRODUCTION = 'PRODUCTION',
}
